import { __read, __spreadArray, __values } from "tslib";
import { WhereOperator } from '@tencent/memoire-core';
import { IntervalMath } from './algorithm/interval';
import { UnsupportedWhereOperatorError, InvalidWhereInValueError } from '../error/errors';
var KeyInterval = /** @class */ (function () {
    function KeyInterval(lower, upper, lowerOpen, upperOpen) {
        this.lower = lower;
        this.upper = upper;
        this.lowerOpen = lowerOpen;
        this.upperOpen = upperOpen;
    }
    KeyInterval.getKeyRange = function (imath, interval) {
        if (interval === undefined) {
            return undefined;
        }
        if (!imath.isValid(interval)) {
            throw new Error('invalid key interval');
        }
        var lower = interval.lower, upper = interval.upper, lowerOpen = interval.lowerOpen, upperOpen = interval.upperOpen;
        if (lower === upper) {
            return lower;
        }
        if (lower !== undefined && upper !== undefined) {
            return IDBKeyRange.bound(lower, upper, lowerOpen, upperOpen);
        }
        if (lower !== undefined) {
            return IDBKeyRange.lowerBound(lower, lowerOpen);
        }
        return IDBKeyRange.upperBound(upper, upperOpen);
    };
    return KeyInterval;
}());
var KeyIntervalGroup = /** @class */ (function () {
    function KeyIntervalGroup(intervals, comparer) {
        var _this = this;
        this.comparer = comparer;
        this.math = new IntervalMath(comparer);
        this.intervals = intervals.filter(function (interval) { return _this.math.isValid(interval); });
    }
    KeyIntervalGroup.fromWherePredicate = function (predicate, comparer) {
        var e_1, _a;
        var group;
        try {
            for (var _b = __values(Object.keys(predicate)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var op = _c.value;
                var value = predicate[op];
                if (value !== undefined) {
                    var next = KeyIntervalGroup.fromWhereExp(op, value, comparer);
                    group = group ? group.intersect(next) : next;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return group || this.createFullGroup(comparer);
    };
    KeyIntervalGroup.fromWhereExp = function (op, value, comparer) {
        var intervals;
        if (op === WhereOperator.In || op === WhereOperator.NotIn) {
            if (!Array.isArray(value)) {
                throw new InvalidWhereInValueError({ op: op });
            }
            var values = value;
            if (op === WhereOperator.In) {
                return values.reduce(function (group, value) { return group.union(KeyIntervalGroup.fromWhereExp(WhereOperator.Equals, value, comparer)); }, this.createEmptyGroup(comparer));
            }
            return values.reduce(function (prev, value, index) {
                var next = KeyIntervalGroup.fromWhereExp(WhereOperator.NotEquals, value, comparer);
                return index ? prev.intersect(next) : next;
            }, this.createFullGroup(comparer));
        }
        switch (op) {
            case WhereOperator.Equals:
                intervals = [new KeyInterval(value, value, false, false)];
                break;
            case WhereOperator.NotEquals:
                intervals = [new KeyInterval(undefined, value, true, true), new KeyInterval(value, undefined, true, true)];
                break;
            case WhereOperator.GreaterThan:
                intervals = [new KeyInterval(value, undefined, true, true)];
                break;
            case WhereOperator.GreaterOrEqualThan:
                intervals = [new KeyInterval(value, undefined, false, true)];
                break;
            case WhereOperator.LessThan:
                intervals = [new KeyInterval(undefined, value, true, true)];
                break;
            case WhereOperator.LessOrEqualThan:
                intervals = [new KeyInterval(undefined, value, true, false)];
                break;
            default:
                throw new UnsupportedWhereOperatorError(op);
        }
        return new KeyIntervalGroup(intervals, comparer);
    };
    KeyIntervalGroup.prototype.union = function (group) {
        return new KeyIntervalGroup(this.math.union(__spreadArray(__spreadArray([], __read(this.intervals)), __read(group.intervals))), this.comparer);
    };
    KeyIntervalGroup.prototype.intersect = function (group) {
        var _a = this.math, cmp = _a.cmp, upperOf = _a.upperOf, lowerOf = _a.lowerOf, intersect = _a.intersect;
        var _b = __read([this.intervals, group.intervals], 2), x = _b[0], y = _b[1];
        var _c = __read([0, 0], 2), i = _c[0], j = _c[1];
        var intervals = [];
        while (i < x.length) {
            while (j < y.length && cmp(upperOf(x[i]), lowerOf(y[j])) >= 0) {
                var overlap = intersect([x[i], y[j]]);
                intervals.push.apply(intervals, __spreadArray([], __read(overlap)));
                j += 1;
            }
            j -= 1;
            i += 1;
        }
        return new KeyIntervalGroup(intervals, this.comparer);
    };
    KeyIntervalGroup.prototype.contains = function (key) {
        var _this = this;
        return !!this.intervals.find(function (interval) { return _this.math.contains(interval, key); });
    };
    KeyIntervalGroup.prototype.isEmpty = function () {
        return this.intervals.length === 0;
    };
    KeyIntervalGroup.prototype.isFull = function () {
        return !!this.intervals.length && this.intervals[0].lower === undefined && this.intervals[0].upper === undefined;
    };
    KeyIntervalGroup.createFullGroup = function (comparer) {
        return new KeyIntervalGroup([new KeyInterval(undefined, undefined, true, true)], comparer);
    };
    KeyIntervalGroup.createEmptyGroup = function (comparer) { return new KeyIntervalGroup([], comparer); };
    return KeyIntervalGroup;
}());
export { KeyIntervalGroup };
export default KeyInterval;
//# sourceMappingURL=key-interval.js.map